'use client';

import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';

import { AnimatedText } from '@/blocks/animations/animated-text';
import { Container } from '@/blocks/components/Container';
import { CenterHeading, Section, VStack } from '@/blocks/components/layout';
import typography from '@/styles/typography.module.scss';

import {
  MtDownloadLinks,
  downloadLinks,
} from '@/app/[lang]/cfd-trading/(pages)/(platforms)/mt5/components/MtDownloadLinks';

import { Device } from '../data';

export const MTDownloadsSection = () => {
  const device = useParams().device as Device;
  const tr = useTranslations('pages.cfdMetaTrader.devices.sections.download');
  const filteredLinks = downloadLinks.filter((link) => link.id !== device);

  return (
    <Section>
      <Container>
        <VStack>
          <CenterHeading>
            <AnimatedText className={typography.h2}>{tr.rich('title')}</AnimatedText>
          </CenterHeading>

          <MtDownloadLinks items={filteredLinks} />
        </VStack>
      </Container>
    </Section>
  );
};
